<template>
  <v-container
    grid-list-md
  >
    <v-layout wrap >
    
  
      <v-flex md4 sm4 xs12>
        <div class="pa-2" style="color: white; background-color: #3e3e3e; border-radius: 10px 10px 0 0; border: 4px solid rgb(255, 255, 255,1); box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.281);"
        >General Risk Rating</div>
        <material-card style="background-image: linear-gradient(to right, rgb(62, 62, 62,.9) , rgb(62, 62, 62)); border-radius: 0 0 10px 10px; border: 4px solid rgb(255, 255, 255,1); box-shadow: 5px 5px 5px 3px rgba(0, 0, 0, 0.281);">
          <Risk></Risk>
       </material-card>
      </v-flex>
         <v-flex md4 sm4 xs12>
        <div class="pa-2" style="color: white; background-color: #3e3e3e; border-radius: 10px 10px 0 0; border: 4px solid rgb(255, 255, 255,1); box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.281);"
        >Gender Stats</div>
        <material-card style="background-image: linear-gradient(to right, rgb(62, 62, 62,.9) , rgb(62, 62, 62)); border-radius: 0 0 10px 10px; border: 4px solid rgb(255, 255, 255,1); box-shadow: 5px 5px 5px 3px rgba(0, 0, 0, 0.281);">
          <Gender></Gender>
        </material-card>
      </v-flex>
      <v-flex md4 sm4 xs12>
        <div class="pa-2" style="color: white; background-color: #3e3e3e; border-radius: 10px 10px 0 0; border: 4px solid rgb(255, 255, 255,1); box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.281);"
        >Working Hours Stats</div>
        <material-card style="background-image: linear-gradient(to right, rgb(62, 62, 62,.9) , rgb(62, 62, 62)); border-radius: 0 0 10px 10px; border: 4px solid rgb(255, 255, 255,1); box-shadow: 5px 5px 5px 3px rgba(0, 0, 0, 0.281);">
          <Hours></Hours>
       </material-card>
      </v-flex>

      
      <v-flex md6 sm6 xs12>
        <div class="pa-2" style="color: white; background-color: #3e3e3e; border-radius: 10px 10px 0 0; border: 4px solid rgb(255, 255, 255,1); box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.281);"
        >Body Parts Stats</div>
        <material-card style="background-image: linear-gradient(to right, rgb(62, 62, 62,.9) , rgb(62, 62, 62)); border-radius: 0 0 10px 10px; border: 4px solid rgb(255, 255, 255,1); box-shadow: 5px 5px 5px 3px rgba(0, 0, 0, 0.281);">
          <Parts></Parts>
       </material-card>
      </v-flex>
      

      <v-flex md6 sm6 xs12>
        <div class="pa-2" style="color: white; background-color: #3e3e3e; border-radius: 10px 10px 0 0; border: 4px solid rgb(255, 255, 255,1); box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.281);"
        >Categories Stats</div>
        <material-card style="background-image: linear-gradient(to right, rgb(62, 62, 62,.9) , rgb(62, 62, 62)); border-radius: 0 0 10px 10px; border: 4px solid rgb(255, 255, 255,1); box-shadow: 5px 5px 5px 3px rgba(0, 0, 0, 0.281);">
        <Categories></Categories>
       </material-card>
      </v-flex>
            <v-flex  xs12>
      <br><br><br>
        <div class="pa-2" style="color: white; background-color: #3e3e3e; border-radius: 10px 10px 0 0; border: 4px solid rgb(255, 255, 255,1); box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.281);"
        >Departments Stats</div>
        <material-card style="background-image: linear-gradient(to right, rgb(62, 62, 62,.9) , rgb(62, 62, 62)); border-radius: 0 0 10px 10px; border: 4px solid rgb(255, 255, 255,1); box-shadow: 5px 5px 5px 3px rgba(0, 0, 0, 0.281);">
          <Departments></Departments>
       </material-card>
      </v-flex>
  
    </v-layout>
  </v-container>
</template>

<script>

import Volume from './export_analytics/Volume';
import Chart from '@/components/charts/Charts';
import Gender from './export_analytics/Gender';
import Risk from './export_analytics/Risk';
import Departments from './export_analytics/Departments';
import Hours from './export_analytics/Hours';
import Parts from './export_analytics/Parts';
import Categories from './export_analytics/Categories';
export default {
  data () {
 
    return {
            collection: {},
            pie: {},
            line: {},
            options: {},
        dailySalesChart: {
          data: {
            labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
            series: [
              [12, 17, 7, 17, 23, 18, 38]
            ]
          },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      dataCompletedTasksChart: {
        data: {
          labels: ['12am', '3pm', '6pm', '9pm', '12pm', '3am', '6am', '9am'],
          series: [
            [230, 750, 450, 300, 280, 240, 200, 190]
          ]
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0
          }),
          low: 0,
          high: 1000, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          }
        }
      },
      emailsSubscriptionChart: {
        data: {
          labels: ['Ja', 'Fe', 'Ma', 'Ap', 'Mai', 'Ju', 'Jul', 'Au', 'Se', 'Oc', 'No', 'De'],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]

          ]
        },
        options: {
          axisX: {
            showGrid: false
          },
          low: 0,
          high: 1000,
          chartPadding: {
            top: 0,
            right: 5,
            bottom: 0,
            left: 0
          }
        },
        responsiveOptions: [
          ['screen and (max-width: 640px)', {
            seriesBarDistance: 5,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value[0]
              }
            }
          }]
        ]
      },
      headers: [
        {
          sortable: false,
          text: 'ID',
          value: 'id'
        },
        {
          sortable: false,
          text: 'Name',
          value: 'name'
        },
        {
          sortable: false,
          text: 'Salary',
          value: 'salary',
          align: 'right'
        },
        {
          sortable: false,
          text: 'Country',
          value: 'country',
          align: 'right'
        },
        {
          sortable: false,
          text: 'City',
          value: 'city',
          align: 'right'
        }
      ],
      items: [
        {
          name: 'Dakota Rice',
          country: 'Niger',
          city: 'Oud-Tunrhout',
          salary: '$35,738'
        },
        {
          name: 'Minerva Hooper',
          country: 'Curaçao',
          city: 'Sinaai-Waas',
          salary: '$23,738'
        }, {
          name: 'Sage Rodriguez',
          country: 'Netherlands',
          city: 'Overland Park',
          salary: '$56,142'
        }, {
          name: 'Philip Chanley',
          country: 'Korea, South',
          city: 'Gloucester',
          salary: '$38,735'
        }, {
          name: 'Doris Greene',
          country: 'Malawi',
          city: 'Feldkirchen in Kārnten',
          salary: '$63,542'
        }
      ],
      tabs: 0,
      list: {
        0: false,
        1: false,
        2: false
      }
    }
 
  },
  methods: {
    complete (index) {
      this.list[index] = !this.list[index]
    },
    fillData(){
        this.line = {
            labels: ['A', 'B', 'C'],
            datasets: [
                {
                    label: 'Data One',
                    borderColor: '#f87979',
                    backgroundColor: 'transparent',
                    data: [10,30,15]
                }, 
                {
                    label: 'Data Two',
                    borderColor: 'green',
                    backgroundColor: 'transparent',
                    data: [20,50,40]
                }, 
                {
                    label: 'Data Three',
                    borderColor: 'Red',
                    backgroundColor: 'transparent',
                    data: [15,60,35]
                }, 
            ],
        }
        this.pie = {
            datasets:[
                {
                    data:[10, 20, 30],
                    backgroundColor: ['green', 'red', 'yellow']

                },
            ],
            labels:['A', 'B', 'C']
        }
        this.collection = {
            labels: ['A', 'B', 'C'],
            datasets: [
                {
                    label: 'Data One',
                    backgroundColor: '#f87979',
                    data: [10,,]
                }, 
                {
                    label: 'Data Two',
                    backgroundColor: '#fff',
                    data: [,20,]
                },
                {
                    label: 'Data Three',
                    backgroundColor: 'green',
                    data: [,,30]
                }
            ],
        }
        this.options ={
            scales:{
                yAxes: [
                    {
                        ticks: {
                            beginAtZero: true
                        }
                    }
                ],
                
            }
        }
    }
  },
  components:{
    Chart,
    Volume,
    Gender,
    Risk,
    Departments,
    Hours,
    Parts,
    Categories
  },
  beforeMount(){
    this.fillData();
  }
}
</script>
